module.exports = __webpack_public_path__ + "img/ic_super_recognition.d9b85d7c.png";